import { Box, Stack, Tab, Tabs } from "@mui/material";

import { type HeaderTabConfig } from "./types";

export const HeaderTabNavigation = ({ headerTabs }: { headerTabs: HeaderTabConfig }) => (
  <Stack width="100%" maxWidth="1244px" alignItems="center" mx="auto">
    <Box sx={{ borderBottom: 1, borderColor: "divider", width: "100%" }}>
      <Tabs
        value={headerTabs.selectedTab}
        onChange={(_, newValue) => {
          headerTabs.onTabChange(newValue);
        }}
      >
        {headerTabs.tabs.map((tab) => (
          <Tab key={tab.value} label={tab.label} value={tab.value} sx={{ textTransform: "none" }} />
        ))}
      </Tabs>
    </Box>
  </Stack>
);
